import { DownloadModal } from './../Modals/DownloadModal';
import { ShareModal } from './../Modals/ShareModal';
import { SearchModal } from './../Modals/SearchModal';
import { FilterModal } from './../Modals/FilterModal';
import { MobilityModal } from './../Modals/MobilityModal';
import { QualityModal } from './../Modals/QualityModal';
import { InvestmentModal } from './../Modals/InvestmentModal';

export const getModalProps = (props) => {
	return {
		filter: FilterModal(props),
		download: DownloadModal(props),
		search: SearchModal(props),
		mobility: MobilityModal(props),
		quality: QualityModal(props),
		investment: InvestmentModal(props),
		share: ShareModal(props),
	};
};
